import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuthService from "../session/useAuthService";

const RequireAuth = ({ allowedRoles }) => {

    
    const authUserType = useAuthService.getUserType();
    const userType = allowedRoles?.includes(authUserType);
    const location = useLocation();

    return (

        userType
            ? <Outlet />
            : !userType
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;